import gql from "graphql-tag";

export default gql`
  fragment BudgetMonthFields on budget_months {
    __typename
    category_id
    year_month
    amount
  }
`;